import {
  ControlledListWithFilter,
  mapChange,
  UpcomingChangesFilter,
  UpcomingChangesItemContent,
} from './UpcomingChangesWrapper';
import { Grid2 as Grid, Typography } from '@mui/material';
import { ProjectSectionAccordion, useProjectDataContext } from 'domain/shared/newProject';
import { ControlledShow, useShowContext } from 'framework/show';
import { merge } from 'lodash';
import { UpcomingChangesType } from './types';
import { useApolloClient } from '@apollo/client/react';
import { GET_TEAM_TAB_DATA } from '../newProject/team/graphql/teamQueries';

const UpcomingChangesLayout = () => {
  const { data: projectData } = useProjectDataContext();
  const { data: teamData, setData: setTeamData } = useShowContext();
  const client = useApolloClient();

  const upcomingChanges = (teamData?.upcomingChanges || []).flatMap((change: UpcomingChangesType) => mapChange(change));

  const handleReloadData = async () => {
    if (!setTeamData) return;
    const { data } = await client.query<{ baseProject: { upcomingChanges?: UpcomingChangesType[] } }>({
      query: GET_TEAM_TAB_DATA,
      variables: { id: projectData.id.toString() },
      fetchPolicy: 'network-only',
    });
    if (data?.baseProject) {
      setTeamData({ ...(teamData?.getData?.() ?? {}), upcomingChanges: data.baseProject.upcomingChanges ?? [] });
    }
  };

  return (
    <ControlledShow data={merge(projectData, teamData)}>
      <ControlledListWithFilter data={upcomingChanges} onReloadData={handleReloadData}>
        <ProjectSectionAccordion
          sx={{
            '.MuiAccordion-region': {
              overflow: 'auto',
            },
          }}
          defaultExpanded
          title={
            <Grid container direction="row" justifyContent="space-between" alignItems="center" width="100%" pl={2}>
              <Grid size={2.3}>
                <Typography variant="h4" color="primary">
                  Upcoming changes
                </Typography>
              </Grid>

              <Grid size="auto" alignItems="center" sx={{ '.filter-item-wrapper': { m: 0 } }}>
                <UpcomingChangesFilter />
              </Grid>

              <Grid size="grow" />
            </Grid>
          }
        >
          <UpcomingChangesItemContent isTeamTab />
        </ProjectSectionAccordion>
      </ControlledListWithFilter>
    </ControlledShow>
  );
};

export default UpcomingChangesLayout;
